import React from 'react';
import { Modal } from '@app/src/common/Modal';
import { useSelector, useDispatch } from 'react-redux';
import { change as changeAction, Field, reduxForm } from 'redux-form';
import {
  Wrapper,
  IconClose,
  FormWrapper,
  CheckboxText,
  FieldWrapper,
  ButtonSend,
  Success
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { FieldForm } from '@app/src/common/FieldForm';
import { renderInput } from '@app/src/common/Input';
import { Title } from '@app/src/common/Title';
import * as validate from '@app/src/utils/validations';
import { maxLength } from '@app/src/utils/normalize';
import { renderSelect } from '@app/src/common/Select';
import { hydrateDataSelectCategories } from '@app/src/views/Home/listProducts';
import { renderCheckbox } from '@app/src/common/Checkbox';
import { COLORS } from '@app/src/ui';
import { fetchLeadHome } from '@app/src/common/formContact';

interface Props {
  handleCloseModal: Function;
  isDisplay: boolean;
  handleSubmit?: Function;
}

const channels = [
  {
    text: 'El Comercio',
    value: 1,
    data: { alias: 'el-comercio' }
  },
  {
    text: 'Trome',
    value: 2,
    data: { alias: 'trome' }
  },
  {
    text: 'Depor',
    value: 3,
    data: { alias: 'depor' }
  },
  {
    text: 'Perú 21',
    value: 4,
    data: { id: 'peru-21' }
  },
]

export const Form: React.FC<Props> = ({
  isDisplay,
  handleCloseModal,
  handleSubmit
}) => {
  const  dispatch = useDispatch();
  const categories = useSelector(state => state.categories.data);
  const isFetching = useSelector(state => state.categories.isFetching);
  const currentCategory: number = useSelector(state => state.form.formInterested.values.section);
  const currentChannel = useSelector(state => state.form.formInterested.values.publishingMedium);
  const isLoading = useSelector(state => state.lead.isFetching);
  const result = useSelector(state => state.lead.data);

  const handleChangeCategory = (section) => {
    dispatch(changeAction('formInterested', 'section', section.alias));
  };

  const handleClickSend = (data) => {
    let json = {...data};
    json['additional'] = Number(data.additional);
    json['termConditions'] = Number(data.termConditions);
    dispatch(fetchLeadHome(json));
  };

  const handleChangeChannel = (data) => {
    dispatch(changeAction('formInterested', 'publishingMedium', data.alias));
  };

  return(
  <Modal show={isDisplay} closeModal={handleCloseModal} customBody>
      <Wrapper>
        <IconClose onClick={handleCloseModal}>
          <Icon data-name="icon-close-bold" fill="#f2f2f2" width="14" height="14" />
        </IconClose>
        {
          result && Object.keys(result).length > 0 ?
          <Success>
            <Title>Gracias por la información, en breves se podrán en contacto contigo a través de tu correo electrónico</Title>
          </Success>
          :
          <FormWrapper onSubmit={handleSubmit}>
            <Title>Avisos desplegados</Title>
            <FieldForm label="Nombre y Apellidos">
              <Field
                name="name"
                component={renderInput}
                maxLength={50}
                validate={[validate.required, validate.minLength3, validate.onlyLetters]} />
            </FieldForm>
            <FieldForm
              label="Correo electrónico"
            >
              <Field
                name="email"
                component={renderInput}
                validate={[validate.required, validate.email]}
              />
            </FieldForm>
            <FieldForm
              label="Teléfono"
            >
              <Field
                name="phone"
                normalize={maxLength(9)}
                component={renderInput}
                validate={[validate.required, validate.minLength6]} />
            </FieldForm>
            <FieldForm label="Sección en la que desea publicar">
              <Field
                name="section"
                component={renderSelect}
                dataList={hydrateDataSelectCategories(categories)}
                handleChange={handleChangeCategory}
                placeholder="Seleccione una categoría"
                modalTitle="Categoría"
                optionColor="#333"
                isLoading={isFetching}
                initialIndex={currentCategory}
                validate={[validate.required]}
              />
            </FieldForm>
            <FieldForm label="Medio de publicación">
              <Field
                name="publishingMedium"
                component={renderSelect}
                dataList={channels}
                handleChange={handleChangeChannel}
                placeholder="Seleccione un canal"
                modalTitle="Medio de publicación"
                optionColor="#333"
                isLoading={isFetching}
                initialIndex={currentChannel}
                validate={[validate.required]}
              />
            </FieldForm>
            <FieldWrapper>
              <Field
                name="termConditions"
                component={renderCheckbox}
                validate={[validate.required]}
                colorActive={COLORS.BLACK}
                value="terms">
                <CheckboxText>
                  He leído y acepto de manera expresa los <a target="_blank" href="/terminos-y-condiciones">Términos y condiciones</a> y la <a target="_blank" href="/politicas-de-privacidad">Política de privacidad.</a>
                </CheckboxText>
              </Field>
            </FieldWrapper>
            <FieldWrapper>
              <Field
                name="additional"
                component={renderCheckbox}
                colorActive={COLORS.BLACK}
                value="add">
                <CheckboxText>
                  Autorizo el uso de mis datos para <a target="_blank" href="/terminos-y-condiciones">fines adicionales.</a>
                </CheckboxText>
              </Field>
            </FieldWrapper>
            <ButtonSend
              handleClick={handleSubmit(handleClickSend)}
              background="#000"
              color="#fff"
              width={144}
              loading={isLoading}
              disabled={isLoading}
            >Enviar</ButtonSend>
          </FormWrapper>
        }
      </Wrapper>
  </Modal>
)};

const FormInterestedHoc = reduxForm({
    form: 'formInterested',
    initialValues: {
      name: '',
      phone: '',
      email: '',
      section: '',
      publishingMedium: '',
      additional: false,
      termConditions: false
    }
  })(Form);
  
  export { FormInterestedHoc as ModalInterested };